
import { useEffect, useState } from "react";
import "../App.css";

const SNOWFLAKE_COUNT = 50;

const getRandom = (min, max) => Math.random() * (max - min) + min;

const createSnowflakes = () => {
  return Array.from({ length: SNOWFLAKE_COUNT }).map((_, i) => ({
    id: i,
    left: getRandom(0, 100),
    duration: getRandom(5, 10),
    opacity: getRandom(0.3, 1),
    fontSize: getRandom(8, 24),
    delay: getRandom(0, 2),
  }));
};

const Snowfall = () => {
  const [show, setShow] = useState(false);
  const [flakes, setFlakes] = useState([]);

  useEffect(() => {
    // Use sessionStorage so snow falls once per session
    if (sessionStorage.getItem("snowFallen")) return;
    setFlakes(createSnowflakes());
    setShow(true);
    sessionStorage.setItem("snowFallen", "true");
    // Hide snowflakes after max duration
    const maxDuration = 12 * 1000;
    const timeout = setTimeout(() => setShow(false), maxDuration);
    return () => clearTimeout(timeout);
  }, []);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none",
        zIndex: 9999,
      }}
    >
      {flakes.map((flake) => (
        <div
          key={flake.id}
          className="snowflake"
          style={{
            left: `${flake.left}vw`,
            animationDuration: `${flake.duration}s`,
            animationDelay: `${flake.delay}s`,
            opacity: flake.opacity,
            fontSize: `${flake.fontSize}px`,
            color: '#7FDBFF', // light blue
            textShadow: '0 0 8px #7FDBFF, 0 0 16px #7FDBFF',
          }}
        >
          ❄
        </div>
      ))}
    </div>
  );
};

export default Snowfall;
// Duplicate code removed. Only one Snowfall component and export remain above.
